import { atom } from "jotai";

type Inset = {
    statusBarHeight: number,
    navigationBarHeight: number,
}

export const insetAtom = atom<Inset>({statusBarHeight: 0, navigationBarHeight: 0})